import { Component, OnInit } from '@angular/core';
import { DataTable, DataTableResource, DataTableTranslations } from 'angular7-data-table';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModalRef, NgbModalOptions, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";
import { ConfirmationComponent } from 'src/app/common/components/confirmation/confirmation.component';
import { PlanService } from '../../plan-management/plan.service';


@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})
export class ViewComponent implements OnInit {

  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "blocked", name: "Blocked" }
  ];
  closeResult: string;
  statusFormSubmitted: boolean = false;
  planDetails: any;
  statusForm: FormGroup;
  featureList = [];
  finalFeatureList = [];
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  coursePlanList = [];
  temp: any;
  feature: string;
  plancount: number;
  plan_id: any;
  planForm:FormGroup;
  formSubmitted:boolean = false;
  headerTitle:string ='Add User'
  constructor(private formBuilder: FormBuilder, private modalService: NgbModal, private PlanService: PlanService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.initialiseForms();
    this.spinner.show();

    this.getplan();
    // this.startLoadingSpinner();
  }

  initialiseForms() {
    this.planForm = this.formBuilder.group({
      email:["", [Validators.required, Validators.pattern(this.emailPattern)]],
      password: ["", [Validators.required,Validators.minLength(6)]],
      fullName: ["", [Validators.required]],
    });
  }
  initialiseForms1() {
    this.planForm = this.formBuilder.group({
      email: ["", [Validators.required]],
      fullName: ["", [Validators.required]],
    });
  }
  startLoadingSpinner() {

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 3000);
  }

  labels = <DataTableTranslations>{
    loadingText: 'Your {title} table is reloading - and this is my custom message.',
    paginationText: 'Your table displays {from} to {to} of {total} rows.'
  };
  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ["", [Validators.required]]
    });
  }
  getplan() {
    this.PlanService.getReportingList().subscribe(res => {
      this.spinner.show();
      if ((res["message"] = "Success")) {
        this.coursePlanList = res.data.reporterList;
        this.plancount = this.coursePlanList.length
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  }



  updateUserStatus(test) {
    this.statusFormSubmitted = true;
    if (this.statusForm.valid) {
      this.spinner.show();
      let finalObj = {
        coursePlanId: this.planDetails["coursePlanId"],
        status: this.statusForm.controls.newStatus.value
      };
      this.PlanService.Editplan(finalObj).subscribe(data => {
        this.spinner.hide();

        if ((data["message"] = "Success")) {
          Swal.fire("Success", "User status updated successfully!", "success");
          this.modalRef.close();
          this.getplan();
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
  }
  AddReport(test) {
    this.formSubmitted = true;
    if (this.planForm.valid) {
      this.spinner.show();
      let finalObj = this.planForm.value;
      this.PlanService.saveReport(finalObj).subscribe(data => {
        this.spinner.hide();

        if ((data["message"] = "Success")) {
          Swal.fire("Success", "Reporter Added successfully!", "success");
          this.modalRef.close();
          this.getplan();
        } else {
          this.spinner.hide();
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      }, err => {
        this.spinner.hide();
      });
    }
  }
  EditReport(test) {
    this.formSubmitted = true;
    if (this.planForm.valid) {
      this.spinner.show();
      let finalObj = this.planForm.value;
      finalObj['reporterId'] = this.planDetails['reporterId']
      this.PlanService.editReport(finalObj).subscribe(data => {
        this.spinner.hide();

        if ((data["message"] = "Success")) {
          Swal.fire("Success", "Reporter updated successfully!", "success");
          this.modalRef.close();
          this.getplan();
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      }, err => {
        this.spinner.hide();
      });
    }
  }

  updateForm(data) {

    this.planForm.patchValue({
      fullName: data.fullName,
      email: data.email
    });

    // this.AsrForm.controls['week'].disable();
  }
  updateUserStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.planDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  updateUserStatusModal2(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    if(row == 'row') {
      this.initialiseForms();
      this.headerTitle ='Add User';
    }else {
      this.headerTitle ='Edit User'
      this.initialiseForms1();
      this.updateForm(row);
    }
    this.planDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  updateUserStatusModal1(row, content, btn) {

    this.plan_id = row.reporterId;
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.planDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  confirmDeleteRecord(record: any) {

    let modalRef = this.modalService.open(ConfirmationComponent, this.modelOptions);
    modalRef.componentInstance.content = "Are you sure you want to delete this record?";
    modalRef.componentInstance.leftButton = "No";
    modalRef.componentInstance.rightButton = "Yes";
    modalRef.result.then(
      (data: any) => {
        if (data == "yes") {
          this.deleteRecord(record);
        }
      },
      (reason: any) => { }
    );
  }

  deleteStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();


    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }


  deleteRecord(record: any) {

    this.spinner.show();

    this.PlanService.deletereport(this.plan_id).subscribe(res => {
      if ((res["status"] = "Success")) {
        Swal.fire("Success", "Reporter Deleted successfully!", "success");
        this.modalRef.close();
        this.spinner.hide();
        this.getplan();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
    this.spinner.hide();

  }
}
